module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_buchung 1.70e767d3.svg";